import { CreateAccreditationMutationProvider } from "__legacy/queries/accreditations/CreateAccreditationMutationProvider";
import { SchemeQueryProvider } from "__legacy/queries/schemes/SchemeQueryProvider";
import { Button, Form, Layout, PageHeader } from "antd";
import { Fragment, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { AccreditationForm, onError, onFinish } from "./AccreditationForm";

export const New: React.FC<{}> = () => {
  const { schemeId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState<string[]>([]);

  return (
    <SchemeQueryProvider variables={{ id: schemeId }}>
      {({ scheme }) => (
        <CreateAccreditationMutationProvider onError={onError(form, setErrors)} onCompleted={() => navigate("../")}>
          {(loading, mutate) => (
            <Fragment>
              <PageHeader
                ghost={true}
                title={`New accreditation for scheme ${scheme.name}`}
                extra={
                  <Fragment>
                    <Button onClick={() => navigate("../../../")}>Back to list</Button>
                    <Button onClick={() => navigate("../")}>Back to accreditations</Button>
                    <Button type="primary" loading={loading} onClick={() => form.submit()}>
                      Save
                    </Button>
                  </Fragment>
                }
              />
              <Layout.Content className="content">
                <AccreditationForm
                  action="create"
                  form={form}
                  handler={onFinish(mutate, { schemeId }, {})}
                  values={{ accreditationClassifications: [] }}
                  errors={errors}
                />
              </Layout.Content>
            </Fragment>
          )}
        </CreateAccreditationMutationProvider>
      )}
    </SchemeQueryProvider>
  );
};
